/**
 * Retourne en fonction d'un user
 * les infos sur ses rôles et ses permissions
 * @module @composables/use-roles
*/
import { reactive, computed, toRefs } from 'vue'
import { useStore } from '@freebe/sdk/store'

export default function useRoles () {
  const { me } = useStore('@admin/users')

  const state = reactive({
    user: computed(() => me.value),
    /**
     * Récupère les rôles du user
    */
    roles: computed(() => state.user?.roles || []),
    /**
     * Récupère les rôles du user
    */
    permissions: computed(() => state.user?.permissions || []),
    /**
     * Si le user est un admin
    */
    isAdmin: computed(() => 
      state.roles.includes('superadmin') || state.roles.includes('admin')
    ),
    /**
     * Si le user est growth
    */
    isGrowth: computed(() => 
      !state.isAdmin && state.roles.includes('growth')
    ),
    /**
     * Si le user est invest
    */
    isInvest: computed(() => 
      !state.isAdmin && checkPermissions('statistics/state:find')
    ),
    /**
     * Si le user est support
    */
    isSupport: computed(() => 
      !state.isAdmin && state.roles.includes('support')
    ),
  })

  function checkRoles (roles) {
    return roles.some(role => state.roles.includes(role))
  }

  function hasRole (roles = []) {
    if (typeof roles === 'string') {
      roles = [roles]
    }

    return roles.some(role => state.roles.includes(role))
  }

  function checkPermissions (permission) {
    const [service, method] = permission.split(':')
    let isAllowed = false 

    for (let i = 0; i < state.permissions.length; i++) {
      const [currentService, currentMethod] = state.permissions[i].split(':')
      
      if (currentService === '*' || currentService === service) {
        if (currentMethod === '*' || currentMethod === method) {
          isAllowed = true
          break
        }
      }
    }

    return isAllowed 
  }

  return {
    ...toRefs(state),
    checkRoles,
    hasRole,
    checkPermissions,
  }
} 
